<template>
  <div :class="assignClassName">
    <div v-if="showPromoName" class="all-promo-info-name">
      <h3>
        {{ item.name }}
        <RfButton
          v-if="promotionView"
          icon="md:edit"
          color="accent"
          iconSize="16"
          class="all-promo-info-name--edit ml-1"
          size="x-small"
          variant="plain"
          density="compact"
          :tooltip="{ location: 'bottom' }"
          :disabled="userStore.isDisabledWithMessage || editDisabled"
          @click="showPromoDetailDialog"
        />
      </h3>
      <span>{{ item.description }}</span>
    </div>
    <div v-if="!pathGroupDisplay && showPromoError" class="list-promo-row-one-right">
      <div v-if="item.sequence_id" class="sequence-pipeline-links">
        <v-icon color="#666" start size="14">fa:fas fa-project-diagram</v-icon> Guide:
        <router-link :to="sequenceLink">{{ item.sequence_name }}</router-link>
      </div>
      <div v-else class="connector-errors-ctr">
        <div v-if="hasConnectorErrors(item)" class="connector-errors-txt">
          <span>Connector errors</span>
          <v-icon style="margin-right: 6px" size="12" color="error"
            >fa:fas fa-exclamation-triangle</v-icon
          >
        </div>
        <div v-if="promoCurrBudgetError(item)" class="connector-errors-txt">
          <span>Budget exceeded</span>
          <v-icon style="margin-right: 6px" size="12" color="error"
            >fa:fas fa-exclamation-triangle</v-icon
          >
        </div>
        <div v-if="promoCurrLimitError(item)" class="connector-errors-txt">
          <span>Limit exceeded</span>
          <v-icon style="margin-right: 6px" size="12" color="error"
            >fa:fas fa-exclamation-triangle</v-icon
          >
        </div>
        <RfPromoPublishStatus :item="item" />
      </div>
    </div>
    <RfEditModal
      v-if="promotionView"
      ref="editModalRef"
      title="Prompt's Name and Description"
      @confirm="submitConfiguration"
    />
  </div>
</template>

<script>
import RfEditModal from "@/components/modals/RfEditModal.vue";
import RfPromoPublishStatus from "@/components/RfPromotions/RfPromoPublishStatus.vue";
import PromoStatusMixin from "@/utils/PromoStatusMixin";
import RfButton from "@/components/buttons/RfButton.vue";
import { cloneDeep } from "lodash-es";
import { useToastsStore } from "@/pinia/toastsStore";
import { usePromptStore } from "@/pinia/promptStore";
import { useUserStore } from "@/pinia/userStore";

export default {
  name: "RfPromoNameInfo",
  components: { RfPromoPublishStatus, RfEditModal, RfButton },
  mixins: [PromoStatusMixin],
  props: [
    "item",
    "promotionView",
    "editDisabled",
    "pathGroupDisplay",
    "showPromoName",
    "showPromoError",
  ],
  setup: () => ({
    toastsStore: useToastsStore(),
    promptStore: usePromptStore(),
    userStore: useUserStore(),
  }),
  computed: {
    sequenceLink() {
      return { path: `/apps/${this.$route.params.aid}/experiences/${this.item.sequence_id}` };
    },
    assignClassName() {
      if (this.showPromoName && !this.showPromoError) {
        return "list-promo-row-one with-promo-title";
      }
      if (!this.showPromoName && this.showPromoError) {
        return "list-promo-row-one error-msg-only";
      }
      if (this.showPromoName && this.showPromoError) {
        return "list-promo-row-one all-msgs";
      }
      return "";
    },
  },
  methods: {
    showPromoDetailDialog() {
      this.$refs.editModalRef?.open({ name: this.item.name, description: this.item.description });
    },
    async submitConfiguration({ name, description }) {
      try {
        const newPath = { ...cloneDeep(this.item), name, description };
        const appId = this.$route.params.aid;
        const pathId = this.$route.params.pid;
        if (!this.pathGroupDisplay) {
          await this.promptStore.updatePrompt({ appId, pathId, modelPath: newPath });
        } else {
          await this.promptStore.updatePathGroup({ appId, model: newPath });
        }
        this.toastsStore.create({ type: "success", body: "Prompt updated successfully" });
      } catch (e) {
        this.toastsStore.create({ type: "error", body: e.message });
      }
    },
  },
};
</script>
